/**
 * @since 8.1.0
 */
export interface CreateRemindersListResult {
  /**
   * Identifier of the newly created reminders list.
   *
   * @platform iOS
   * @since 8.1.0
   */
  id: string;
}
